import PackageInfo from '../../../../package.json';
import {
  AppLogger,
  DatadogClient,
  RumInitConfiguration,
  LogsInitConfiguration,
} from '@workivate/tho-web-shared';
import { IS_PRODUCTION } from 'utils/check-environment/check-environment';

const deploymentEnvironment = import.meta.env.DEPLOYMENT_ENVIRONMENT ?? '';
const commonDatadogConfig = {
  clientToken: import.meta.env.DD_CLIENT_TOKEN ?? '',
  env:
    deploymentEnvironment === 'live' // Use 'prod' instead of 'live' for DataDog env tag to make it consistent with other environments,
      ? 'prod'
      : deploymentEnvironment,
  service: 'usl',
  version: `${PackageInfo.version}_${deploymentEnvironment}`, // This version must match with the version that is referenced in web_cicd.yml
};

const dataDogRUMConfig: RumInitConfiguration = {
  applicationId: import.meta.env.DD_APP_ID ?? '',
  ...commonDatadogConfig,
  trackUserInteractions: true,
};

const dataDogLogsConfig: LogsInitConfiguration = {
  ...commonDatadogConfig,
};

export const initialiseDataDog = () => {
  DatadogClient.initDataDog(dataDogLogsConfig, dataDogRUMConfig);

  AppLogger.configure({
    isProduction: IS_PRODUCTION,
    datadogLogger: (message, context) => {
      const ctx = (context ?? {}) as { level?: string; error?: string };

      if (ctx.error) {
        DatadogClient.addError(new Error(ctx.error), {
          logMessage: message,
          ...(ctx.level && { level: ctx.level }),
        });
      }

      DatadogClient.logMessage(message, context);
    },
  });
};
